







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class MIconButton extends Vue {
  @Prop({ default: "mdi-pencil-outline" }) icon!: string;
  @Prop({ type: Boolean, default: false }) xSmall!: boolean;
  @Prop({ type: Boolean, default: false }) small!: boolean;
  @Prop({ type: Boolean, default: false }) large!: boolean;
  @Prop({ type: Boolean, default: false }) xLarge!: boolean;

  get sizePx(): number {
    if (this.xSmall) return 24;
    if (this.small) return 28;
    if (this.large) return 48;
    if (this.xLarge) return 56;
    return 36; // default
  }

  get iconSize(): number {
    if (this.xSmall) return 16;
    if (this.small) return 20;
    if (this.large) return 28;
    if (this.xLarge) return 32;
    return 24; // default
  }
}
